import { j as a } from "../../../jsx-runtime-B6kdoens.js";
import { w as s } from "../../../atom-provider-B3P183Tj.js";
import { c as i, f as x } from "../../../create-component-CBAeEoQ6.js";
import { u as f } from "../../../use-sync-atom-value-CDr7vapO.js";
import { Card as p } from "../index.js";
import { createTextCardState as d, TextCardContext as n, useTextCardStateAtoms as C } from "./TextCardState/index.js";
const S = s(
  i(
    "TextCard",
    x(
      ({ children: t, size: r, ...o }, e) => {
        const { sizeAtom: m } = C();
        return f(m, r), /* @__PURE__ */ a.jsx(p, { ref: e, ...o, children: t });
      }
    )
  ),
  n,
  d
);
export {
  S as TextCard
};
//# sourceMappingURL=index.js.map
